var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"overview container-fluid p-3"},[_c('div',{staticClass:"position-sticky title d-flex pb-2 mb-2"},[_c('div',{staticClass:"d-flex d-xl-none align-items-center"},[_c('button-toggle-side-bar')],1),_c('h1',{staticClass:"display-4 font-weight-bolder col pl-xl-0 mb-0"},[_vm._v(" Overview ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }